module.exports = __webpack_public_path__ + "img/L3.b92a80b3.png";